export default {
  name: 'CurrencyData',
  data: () => ({
    currency: {
      symbol: window.CURRENCY_DATA.symbol,
    },
  }),
}
